<script>
  import { auth, db } from "../etc/firebase.js"
  import PrivatePage from "./PrivatePage.svelte"
  import "materialize-css"
  import Note from "./Note.svelte"
  import marked from "marked"
  import {
    btn_style_blue_d2,
    btn_style_red_l3,
    btn_style_teal,
  } from "../etc/helpers.js"

  let notes = []
  let title = ""
  let content = ""
  let published = false
  let showForm = false

  // add note
  const addNote = () => {
    const createdDT = new Date().getTime()
    let updatedDT = createdDT
    db.collection("notes").add({
      createdDT,
      updatedDT,
      title,
      published,
      content,
    })

    title = ""
    content = ""
    published = false
    showForm = false
  }

  function showNoteForm() {
    showForm = !showForm
  }

  let showNews = false
  const showNewsList = () => {
    showNews = !showNews
  }
  // Listen for auth status change
  let isLogin = false
  let email = ""
  auth.onAuthStateChanged((user) => {
    if (user) {
      isLogin = true
      // console.log("@ Notes: " + user.email + " logged in!")
      email = user.email

      // get notes data from Firebase db
      db.collection("notes")
        .orderBy("createdDT")
        .onSnapshot((data) => {
          // console.log(data.docs)
          notes = data.docs
        })
    } else {
      //notes = []
      isLogin = false
      email = ""
      // console.log(email + " just logged out!")
    }
  })
</script>

<main>
  {#if isLogin}
    <div class="btn-row">
      <button class={btn_style_blue_d2} on:click={showNoteForm}>Add News</button
      >
      <button class={btn_style_teal} on:click={showNewsList}
        >List All News</button
      >
    </div>

    <div id="add-news" class="" style="display:{showForm ? 'block' : 'none'}">
      <h5>News Editor</h5>
      <br />
      <form id="notes-form">
        <div class="input-field">
          <input type="text" id="title" bind:value={title} required />
          <label for="title">News Title</label>
        </div>
        <div class="input-field">
          <p>
            <label>
              <input type="checkbox" bind:checked={published} />
              <span>Go Publish</span>
            </label>
          </p>
          <br />
        </div>

        <div class="markdown-text">
          <label for="markdown">News Content</label>
          <textarea
            bind:value={content}
            placeholder="Enter markdown text here"
          />
        </div>

        <button class={btn_style_blue_d2} on:click={addNote}>Create</button>
        <button class={btn_style_red_l3} on:click={showNoteForm}>Cancel</button>
      </form>

      <!-- Convert the markdown to HTML and display it -->
      <div class="preview">{@html marked(content)}</div>
    </div>

    <!-- NOTES LIST -->
    <div class="news-list" style="display:{showNews ? 'block' : 'none'}">
      <h5>List of News</h5>
      <div class="collection">
        {#each notes as note}
          {#if isLogin | note.published}
            <Note id={note.id} note={note.data()} />
          {/if}
        {/each}
      </div>
    </div>
  {:else}
    <PrivatePage />
  {/if}
</main>

<style>
  #add-news {
    background-color: #ddffee;
  }
  .btn-single {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  textarea,
  .preview {
    box-sizing: border-box;
    display: block;
    width: 100%;
  }

  textarea {
    font-family: monospace, Roboto;
    height: 200px;
    border: none;
    margin: 0;
    padding: 1rem;
  }

  .preview {
    height: 75%;
    padding: 2rem;
    border-top: solid 2px #888;
  }
</style>
